import omit from 'lodash/omit'

export const WebIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...omit(props, 'fill')}
  >
    <path
      d="M11.9961 22C17.5189 22 21.9961 17.5228 21.9961 12C21.9961 6.47715 17.5189 2 11.9961 2C6.47325 2 1.99609 6.47715 1.99609 12C1.99609 17.5228 6.47325 22 11.9961 22Z"
      stroke={props.fill || '#350174'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.99609 12H21.9961"
      stroke={props.fill || '#350174'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9961 2C14.4974 4.73835 15.9188 8.29203 15.9961 12C15.9188 15.708 14.4974 19.2616 11.9961 22C9.49481 19.2616 8.07334 15.708 7.99609 12C8.07334 8.29203 9.49481 4.73835 11.9961 2Z"
      stroke={props.fill || '#350174'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
